"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../utils/helpers");
var _LogoListItemModule = _interopRequireDefault(require("./../../scss/LogoListItem.module.scss"));
function LogoListItem(_ref) {
  let {
    imageSource,
    href = '',
    altText = '',
    target = '_self'
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, href !== '' && /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _helpers.classes)([_LogoListItemModule.default['icon-list-item'], 'icon-list-item'])
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    className: (0, _helpers.classes)([_LogoListItemModule.default['icon-list-item__link'], 'icon-list-item__link']),
    target: target
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, altText), /*#__PURE__*/_react.default.createElement("img", {
    src: imageSource,
    alt: "".concat(altText, " logo"),
    className: _LogoListItemModule.default['ion-list-item__image']
  }))), href === '' && /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _helpers.classes)([_LogoListItemModule.default['icon-list-item'], 'icon-list-item'])
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _helpers.classes)([_LogoListItemModule.default['icon-list-item__img-wrapper'], 'icon-list-item__img-wrapper'])
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: imageSource,
    alt: "".concat(altText, " logo")
  }))));
}
var _default = exports.default = LogoListItem;